import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import InputField from '../../components/InputField';
import PageLayout from '../../components/PageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { residenceHistorySelector } from '../../reducers/selectors';

const CurrentAddressPage = ({ residenceHistory, dispatchAddPageData, dispatchWizardNav }) => {
  const [currentResidence, ...otherResidences] = residenceHistory;
  const {
    address: initialAddress,
    city: initialCity,
    postCode: initialPostCode,
  } = currentResidence;
  const [address, setAddress] = useState(initialAddress || '');
  const [city, setCity] = useState(initialCity || '');
  const [postCode, setPostCode] = useState(initialPostCode || '');

  const onAddressChanged = event => setAddress(event.target.value);
  const onCityChanged = event => setCity(event.target.value);
  const onPostCodeChanged = event => setPostCode(event.target.value);

  const isInvalid = address.trim() === '' || city.trim() === '' || postCode.trim() === '';

  const handleSubmit = event => {
    event.preventDefault();
    if (isInvalid) return;

    analytics.sendEvent('Click - Next', 'current-address');

    const updatedResidenceHistory = [
      {
        ...currentResidence,
        address,
        city,
        postCode,
      },
      ...otherResidences,
    ];

    const residenceHistoryPayload = payloadFactory.createAddPageDataPayload(
      'residenceHistory',
      updatedResidenceHistory,
    );
    dispatchAddPageData(residenceHistoryPayload);

    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <PageLayout title="What is your current address?">
      <div className="row">
        <form className="col col--8/16-small" onSubmit={handleSubmit}>
          <div className="row-spacer">
            <InputField
              type="text"
              label="Address"
              id="address"
              value={address}
              maxLength={200}
              onChange={onAddressChanged}
            />
          </div>
          <div className="row-spacer">
            <InputField
              type="text"
              label="City"
              id="city"
              value={city}
              maxLength={200}
              onChange={onCityChanged}
            />
          </div>
          <div className="row-spacer">
            <InputField
              type="text"
              label="Post code"
              id="postCode"
              value={postCode}
              maxLength={200}
              onChange={onPostCodeChanged}
            />
          </div>
          <div className="row-spacer">
            <Button type="submit" isDisabled={isInvalid}>
              Next
            </Button>
          </div>
        </form>
      </div>
    </PageLayout>
  );
};

CurrentAddressPage.propTypes = {
  residenceHistory: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
      stateCode: PropTypes.string.isRequired,
      address: PropTypes.string,
      city: PropTypes.string,
      postCode: PropTypes.string,
      startMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      startYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

export const mapStateToProps = state => ({
  residenceHistory: residenceHistorySelector(state),
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { CurrentAddressPage };

export default connect(mapStateToProps, mapDispatchToProps)(CurrentAddressPage);
